export default {"id":"0b923787","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}